module.exports = __webpack_public_path__ + "system/static/img/coin.935559ed.png";